// extracted by mini-css-extract-plugin
module.exports = {"subscriptionCardsList":"Subscriptions_subscriptionCardsList__wJJw1","subscriptionCardListItem":"Subscriptions_subscriptionCardListItem__SqYUK"};